import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, Card, CardBody, Form, Row, Col, Collapse } from "reactstrap";
import InputResposta from "../../../components/Inputs/InputResposta";

// helpers
import { showMessage } from "../../../helpers/message.js";

// views
import VistoriaOnlineListaBoletinsVinculados from './VistoriaOnlineListaBoletinsVinculados';

export default function VistoriaOnlineCabecalho({ formularioVistoria, handleAvancar, handleCancelar, boletinsVinculados }) {

    const { handleSubmit } = useForm({ mode: "onBlur" });

    const [showBoletinsVinculados, set_showBoletinsVinculados] = useState(false);
    const [listaCabecalho, set_listaCabecalho] = useState([]);

    const handleUpdateCabecalho = (id, valor) => {
        let _lista = listaCabecalho.filter(f => f.formularioVistoriaCabecalho_Id != id);
        if (valor) {
            _lista.push({
                identificacao: formularioVistoria.cabecalho.filter(f => f.formularioVistoriaCabecalho_Id == id)[0].identificacao,
                formularioVistoriaCabecalho_Id: id,
                valor: valor,
            });
        }
        set_listaCabecalho(_lista);
    }

    const onSubmit = (data) => {
        if (formularioVistoria.cabecalho.filter(f => listaCabecalho.filter(x => x.formularioVistoriaCabecalho_Id == f.formularioVistoriaCabecalho_Id).length == 0 && f.obrigatorio).length > 0) {
            showMessage("Aviso", "Responda todas as questões obrigatórias", 'error', null);
            return;
        }
        handleAvancar(listaCabecalho);
    }

    return (
        <>
            <Card>
                <CardBody>
                    {boletinsVinculados != null && boletinsVinculados.length > 0 &&
                        <>
                            <h5 Style={{ cursor: "pointer" }} className="subtitleCard" onClick={() => set_showBoletinsVinculados(!showBoletinsVinculados)}>Boletins Vinculados para Análise
                                &nbsp;<i className={showBoletinsVinculados ? "fas fa-chevron-down fa-cursor" : "fas fa-chevron-up fa-cursor"}></i>
                            </h5>
                            <Collapse isOpen={showBoletinsVinculados}>
                                <VistoriaOnlineListaBoletinsVinculados boletinsVinculados={boletinsVinculados}></VistoriaOnlineListaBoletinsVinculados>
                            </Collapse>
                        </>
                    }
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col lg="12" md="12" sm="12" className="text-right">
                                <strong className="text-danger">* Campos Obrigatórios</strong>
                            </Col>
                        </Row>
                        <h5 className="subtitleCard">Cabeçalho</h5>
                        <Row className="align-items-end">
                            {formularioVistoria.cabecalho.map((m, key) => (
                                <Col lg="4" md="6" sm="12" key={key}>
                                    <InputResposta
                                        id={m.formularioVistoriaCabecalho_Id}
                                        key={key}
                                        typeInput={m.tipoValor}
                                        editable={formularioVistoria.editable}
                                        label={m.identificacao}
                                        listaOpcoes={m.opcoesResposta}
                                        obrigatorio={m.obrigatorio}
                                        handleChangeValor={(id, value) => handleUpdateCabecalho(id, value)}
                                    >
                                    </InputResposta>
                                </Col>
                            ))}
                        </Row>
                        <Row>
                            <Col lg="12" md="12" sm="12" className="text-center">
                                <Button color="default" type="button" onClick={handleCancelar}>
                                    Cancelar
                                </Button>
                                <Button color="success" type="submit"><i className="fas fa-arrow-right"></i>
                                    Avançar
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </CardBody>
            </Card>
        </>
    );
}

